module.exports = __webpack_public_path__ + "img/redit.sh.a4df7e87.svg";